export const IMPORT_INIT = 'IMPORT_INIT';
export const IMPORT_LOADING = 'IMPORT_LOADING';
export const IMPORT_STEP_1 = 'IMPORT_STEP_1';
export const IMPORT_STEP_2 = 'IMPORT_STEP_2';

export const IMPORT_CHANGE_PROVIDER_ID = 'IMPORT_CHANGE_PROVIDER_ID';
export const IMPORT_CHANGE_PROVIDER_FORM_SUCCESS = 'IMPORT_CHANGE_PROVIDER_FORM_SUCCESS';
export const IMPORT_CHANGE_PROVIDER_FORM_ERROR = 'IMPORT_CHANGE_PROVIDER_FORM_ERROR';
export const IMPORT_CHANGE_SEARCH = 'IMPORT_CHANGE_SEARCH';
export const IMPORT_CHANGE_SEARCH_SUCCESS = 'IMPORT_CHANGE_SEARCH_SUCCESS';
export const IMPORT_CHANGE_RATE = 'IMPORT_CHANGE_RATE';
export const IMPORT_CHANGE_RATE_FIXED = 'IMPORT_CHANGE_RATE_FIXED';
export const IMPORT_CHANGE_RATE_PERCENT = 'IMPORT_CHANGE_RATE_PERCENT';
export const IMPORT_CHANGE_RATE_SYNC = 'IMPORT_CHANGE_RATE_SYNC';
export const IMPORT_CHANGE_RATE_SYNC_SUCCESS = 'IMPORT_CHANGE_RATE_SYNC_SUCCESS';
export const IMPORT_CHANGE_RATE_LOADING = 'IMPORT_CHANGE_RATE_LOADING';
export const IMPORT_CHANGE_CATEGORY = 'IMPORT_CHANGE_CATEGORY';
export const IMPORT_SORT_BY_RATE = 'IMPORT_SORT_BY_RATE';
export const IMPORT_RESET_RAISE = 'IMPORT_RESET_RAISE';
export const IMPORT_SERVICE_SELECTED_ADD = 'IMPORT_SERVICE_SELECTED_ADD';
export const IMPORT_SERVICE_SELECTED_DELETE = 'IMPORT_SERVICE_SELECTED_DELETE';
export const IMPORT_SERVICE_SELECTED_ALL_ADD = 'IMPORT_SERVICE_SELECTED_ALL_ADD';
export const IMPORT_SERVICE_SELECTED_ALL_DELETE = 'IMPORT_SERVICE_SELECTED_ALL_DELETE';
export const IMPORT_SERVICE_LOCKED = 'IMPORT_SERVICE_LOCKED';
export const IMPORT_SUBMIT = 'IMPORT_SUBMIT';
export const IMPORT_SUBMIT_SUCCESS = 'IMPORT_SUBMIT_SUCCESS';
export const IMPORT_SUBMIT_ERROR = 'IMPORT_SUBMIT_ERROR';
export const IMPORT_CHANGE_DESCRIPTION = 'IMPORT_CHANGE_DESCRIPTION';
export const IMPORT_TOGGLE_ADDED_VISIBLE = 'IMPORT_TOGGLE_ADDED_VISIBLE';
export const IMPORT_TOGGLE_EDIT_CATEGORY = 'IMPORT_TOGGLE_EDIT_CATEGORY';
export const IMPORT_TOGGLE_COLLAPSE_CATEGORY = 'IMPORT_TOGGLE_COLLAPSE_CATEGORY';
export const IMPORT_TOGGLE_INFO_SERVICE = 'IMPORT_TOGGLE_INFO_SERVICE';
export const IMPORT_TOGGLE_EDIT_SERVICE = 'IMPORT_TOGGLE_EDIT_SERVICE';
export const IMPORT_CHANGE_SERVICE_FORM = 'IMPORT_CHANGE_SERVICE_FORM';
export const IMPORT_SAVE_SERVICE_CHANGES = 'IMPORT_SAVE_SERVICE_CHANGES';
